module.exports = __webpack_public_path__ + "img/typing_dos_banner.3889d941.png";